var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"default","loading":_vm.isInserting},on:{"click":_vm.insertTemplate}},[_c('a-icon',{attrs:{"type":"import"}}),_vm._v(" Nhập word template ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }